import React from 'react';
import { Spin } from 'antd';

export default ({ style }) => (
  <Spin className="Loading" spinning style={style} />
);
